import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ClientCardRequestComponent } from './client-cardrequest.component';

import { SharedModule } from '../../shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {FormsModule} from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ClientCardRequestComponent
  ],
  imports: [
    BrowserModule,
    MatIconModule,
    FlexLayoutModule,
    SharedModule,
    MatCardModule,
    MatCheckboxModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    ClientCardRequestComponent
  ],
  entryComponents: [],
  providers: []
})
export class ClientCardRequestModule {}
